/**
 * gallery.js — đổi ảnh lớn khi bấm ảnh nhỏ ở trang chi tiết sản phẩm.
 *
 * Markup: [data-gallery] chứa img[data-gallery-main] và các
 *         button[data-gallery-thumb][data-src].
 * Dùng <button> chứ không phải <div> nên bàn phím tab tới và Enter/Space chạy được.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || !thumbs.length) return;

    // Tải trước ảnh còn lại để đổi ảnh không bị nháy trắng
    thumbs.forEach(function (thumb) {
        var src = thumb.getAttribute('data-src');
        if (src) new Image().src = src;
    });

    thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-src');
            if (!src || main.getAttribute('src') === src) return;

            main.setAttribute('src', src);

            thumbs.forEach(function (other) {
                var active = other === thumb;
                other.classList.toggle('is-active', active);
                if (active) {
                    other.setAttribute('aria-current', 'true');
                } else {
                    other.removeAttribute('aria-current');
                }
            });
        });
    });
})();
